import { ReactComponent as PrintIcon } from "assets/products/shared/icons/print.svg";
import { printElement, PrintOptions } from "utils/printUtils";
import React from "react";

interface PrintButtonProps {
    elementId: string;
    title?: string;
    customStyles?: string;
    showPrintDialog?: boolean;
    className?: string;
    children?: React.ReactNode;
}

const PrintButton = ({
    elementId,
    title = "Print",
    customStyles = "",
    showPrintDialog = true,
    className = "btn bg-base-200 font-semibold text-sm flex gap-2 text-base-content border-none hover:bg-white/80 min-h-0 h-[40px] w-[98px] print:hidden",
    children,
}: PrintButtonProps) => {
    const handlePrint = (): void => {
        const options: PrintOptions = {
            elementId,
            title,
            customStyles,
            showPrintDialog,
        };

        printElement(options);
    };

    return (
        <button className={className} onClick={handlePrint}>
            <PrintIcon />
            {children || "Print"}
        </button>
    );
};

export default PrintButton;
